<template>
  <div class="recharge-root">
    <div class="custom-nav-block" :style="`padding-top:${topBarHeight}px`">
      <van-nav-bar class="van-bar" title="" left-arrow @click-left="closeWeb">
        <template #left>
          <img class="left-nav" src="@/assets/packageAssets/common/arrow01.webp" alt="" />
        </template>
      </van-nav-bar>
    </div>

    <div class="recharge-top">
      <img v-if="$i18n.locale === 'ar'" class="recharge-tit" src="./images/bg-ar.webp" alt="" />
      <img v-else-if="$i18n.locale === 'es'" class="recharge-tit" src="./images/bg-es.webp" alt="" />
      <img v-else-if="$i18n.locale === 'fr'" class="recharge-tit" src="./images/bg-fr.webp" alt="" />
      <img v-else-if="$i18n.locale === 'id'" class="recharge-tit" src="./images/bg-id.webp" alt="" />
      <img v-else-if="$i18n.locale === 'pt'" class="recharge-tit" src="./images/bg-pt.webp" alt="" />
      <img v-else-if="$i18n.locale === 'tr'" class="recharge-tit" src="./images/bg-tr.webp" alt="" />
      <img v-else class="recharge-tit" src="./images/bg-en.webp" alt="" />

      <div class="rec-date-block">
        <img src="./images/top-bg.webp" />

        <div class="recharge-date-block">
          <div class="recharge-date">
            <span>{{ $t('lang.NewguyWheelPan.k015') }}</span>
            <span>{{ showTime }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="recharge-con top-mg25">
      <div class="recharge-tit">
        <img src="./images/tips-star.webp" />
        <template v-if="baseInfo && baseInfo.hasDrawn === true">
          {{ $t('lang.NewguyWheelPan.k016') }}
        </template>
        <template v-else>
          {{ $t('lang.NineDotNinetyNine.k001') }}
        </template>
        <img src="./images/tips-star.webp" />
      </div>

      <div class="wheel-pan">
        <div class="outher">
          <div v-if="baseInfo" ref="wapper" class="wapper">
            <div class="part1">
              <div
                v-if="panData && panData[0]"
                class="item one"
                :class="{ gotted: baseInfo.hasDrawn === true && baseInfo.lastDrawId === panData[0].id }"
              >
                <div class="text">
                  <div>
                    <span class="discount">{{ panData[0].discount }}</span>
                    <span class="union">%</span>
                  </div>
                  <div class="txt">{{ $t('lang.CommonModule.k018') }}</div>
                </div>
              </div>
              <div
                v-if="panData && panData[1]"
                class="item two"
                :class="{ gotted: baseInfo.hasDrawn === true && baseInfo.lastDrawId === panData[1].id }"
              >
                <div class="text">
                  <div>
                    <span class="discount">{{ panData[1].discount }}</span>
                    <span class="union">%</span>
                  </div>
                  <div class="txt">{{ $t('lang.CommonModule.k018') }}</div>
                </div>
              </div>
              <div
                v-if="panData && panData[2]"
                class="item three"
                :class="{ gotted: baseInfo.hasDrawn === true && baseInfo.lastDrawId === panData[2].id }"
              >
                <div class="text">
                  <div>
                    <span class="discount">{{ panData[2].discount }}</span>
                    <span class="union">%</span>
                  </div>
                  <div class="txt">{{ $t('lang.CommonModule.k018') }}</div>
                </div>
              </div>
            </div>
            <div class="part2">
              <div
                v-if="panData && panData[3]"
                class="item four"
                :class="{ gotted: baseInfo.hasDrawn === true && baseInfo.lastDrawId === panData[3].id }"
              >
                <div class="text">
                  <div>
                    <span class="discount">{{ panData[3].discount }}</span>
                    <span class="union">%</span>
                  </div>
                  <div class="txt">{{ $t('lang.CommonModule.k018') }}</div>
                </div>
              </div>
              <div
                v-if="panData && panData[4]"
                class="item five"
                :class="{ gotted: baseInfo.hasDrawn === true && baseInfo.lastDrawId === panData[4].id }"
              >
                <div class="text">
                  <div>
                    <span class="discount">{{ panData[4].discount }}</span>
                    <span class="union">%</span>
                  </div>
                  <div class="txt">{{ $t('lang.CommonModule.k018') }}</div>
                </div>
              </div>
              <div
                v-if="panData && panData[5]"
                class="item six"
                :class="{ gotted: baseInfo.hasDrawn === true && baseInfo.lastDrawId === panData[5].id }"
              >
                <div class="text">
                  <div>
                    <span class="discount">{{ panData[5].discount }}</span>
                    <span class="union">%</span>
                  </div>
                  <div class="txt">{{ $t('lang.CommonModule.k018') }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="wheel-pointer"></div>
      </div>

      <div class="recharge-con-block">
        <!-- Free Spin -->
        <div v-if="baseInfo && baseInfo.hasDrawn === false" class="con-block-btn" @click="handleWheelPan">
          <span>{{ $t('lang.NewguyWheelPan.k017') }}</span>
          <div class="btn-tips-root">
            <div class="btn-tips-con">
              <span>{{ $t('lang.NewguyWheelPan.k018') }}</span>
              <img src="./images/tips-trangle.webp" />
            </div>
          </div>
        </div>

        <template v-if="baseInfo && baseInfo.hasDrawn === true">
          <div class="con-block-btn disable">
            <span>{{ $t('lang.NewguyWheelPan.k017') }}</span>
          </div>
          <p class="recharge-tips">{{ $t('lang.NineDotNinetyNine.k004') }}</p>
        </template>
      </div>
    </div>

    <div class="recharge-con">
      <div class="recharge-con-block pd-24">
        <div class="recharge-coins">
          <img :src="getMatchImg('coin')" />
          <i v-if="baseInfo">{{ baseInfo.amount || '' }}</i>
        </div>
        <div class="rec-fir-deliver">
          <div class="deliver-l">
            <div></div>
          </div>
          <div class="rec-fir-deliver-text">
            {{ $t('lang.NineDotNinetyNine.k005') }}
          </div>
          <div class="deliver-r">
            <div></div>
          </div>
        </div>

        <div v-if="baseInfo && baseInfo.presentPropList && baseInfo.presentPropList.length" class="rec-gifts">
          <template v-for="item in baseInfo.presentPropList">
            <div v-if="item.propType == 1" class="gift-item">
              <img :src="getMatchImg('chat-pass')" />
              <div>x{{ item.number }}</div>
            </div>
            <div v-else-if="item.propType == 2" class="gift-item">
              <img :src="getMatchImg('video-pass')" />
              <div>x{{ item.number }}</div>
            </div>
            <div v-else-if="item.propType == 4" class="gift-item">
              <img :src="getMatchImg('vip')" />
              <div>x{{ item.number }}</div>
            </div>
            <div v-else-if="item.propType == 6" class="gift-item">
              <img :src="getMatchImg('call-pass')" />
              <div>x{{ item.number }}</div>
            </div>
            <div v-else-if="item.propType == 9" class="gift-item">
              <img :src="getMatchImg('coupon')" />
              <div>x{{ item.number }}</div>
            </div>
            <div v-else-if="item.propType == 15" class="gift-item">
              <img :src="getMatchImg('super-chat-pass')" />
              <div>x{{ item.number }}</div>
            </div>
          </template>
        </div>
      </div>
    </div>

    <!-- 去支付按钮-置灰 -->
    <template v-if="baseInfo && baseInfo.hasDrawn === false">
      <div class="recharge-con-tips">{{ $t('lang.NineDotNinetyNine.k002') }}</div>
      <div class="recharge-btn cannot-claim">
        <i>{{ $t('lang.CommonModule.k014') }}</i>
        <span>{{ baseInfo.currency }} {{ handleDiv100(baseInfo.originPrice) }}</span>
      </div>
    </template>

    <!-- 去支付按钮-可用 -->
    <div v-if="baseInfo && baseInfo.hasDrawn === true" class="recharge-btn mt-60" @click="handleClaim">
      <img :src="baseInfo.currencyIcon | imgPath" />
      <i>{{ baseInfo.currency }} {{ handleDiv100(baseInfo.price) }}</i>
      <span>{{ baseInfo.currency }} {{ handleDiv100(baseInfo.originPrice) }}</span>
      <div class="discount">{{ baseInfo.discountDesc }} {{ $t('lang.CommonModule.k018') }}</div>
    </div>

    <div v-if="showDia && baseInfo.discountDesc" class="mask">
      <div class="dialog">
        <div>{{ $t('lang.NewguyWheelPan.k016') }}</div>
        <div>{{ baseInfo.discountDesc }}</div>
        <div>{{ $t('lang.CommonModule.k018') }}</div>
        <div @click="handleCloseDia">{{ $t('lang.NineDotNinetyNine.k003') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiNineDotNinetyNineAct, apiNineDotNinetyNineDraw } from './apidir/api.js'
import { compareVersion } from '@/utils/common.js'

export default {
  data() {
    return {
      // 转盘数据
      isWheeling: false,
      panData: [
        // {
        //   id: '0',
        //   discount: 5,
        //   ratio: 0
        // }
      ],

      appInfo: null,

      // 页面数据
      baseInfo: null,
      // 倒计时
      lastTime: 0,
      endTime: 0,
      showTime: '00:00:00',
    }
  },
  methods: {
    handleCloseDia() {
      this.showDia = false

      try {
        if (document.body) {
          let top = 5000
          if (document.body.scrollHeight) {
            top = document.body.scrollHeight
          }
          document.body.scrollTo({ top: top, behavior: 'smooth' })
        }
      } catch (err) {
        console.log('try catch err:', err)
      }
    },
    // 转盘方法
    handleWheelPan() {
      if (!this.baseInfo.hasDrawn && !this.isWheeling) {
        apiNineDotNinetyNineDraw().then((resData) => {
          if (resData && !resData.error) {
            const originIndex = this.panData.findIndex((item) => item.id === resData.lastDrawId)
            if (originIndex > -1) {
              // 调用接口上报点击事件
              const cbFn = () => {
                this.baseInfo = resData
                this.showDia = true
              }
              switch (originIndex) {
                case 0:
                  this.doWheelPan(-30, cbFn)
                  break
                case 1:
                  this.doWheelPan(270, cbFn)
                  break
                case 2:
                  this.doWheelPan(210, cbFn)
                  break
                case 3:
                  this.doWheelPan(150, cbFn)
                  break
                case 4:
                  this.doWheelPan(90, cbFn)
                  break
                case 5:
                  this.doWheelPan(30, cbFn)
                  break
              }

              this.traceAction({ Action: 'Click', APosition: 'button', AValue: 'repurchase-9.99-click-wheel' })
            }
          }
        })
      }
    },
    doWheelPan(angle, fn) {
      this.isWheeling = true

      let begin = 0
      const basic = 1800

      const timer = setInterval(() => {
        if (begin > basic + angle) {
          this.isWheeling = false
          clearInterval(timer)
          fn && fn()
        }
        this.$refs.wapper.style.transform = 'rotate(' + begin + 'deg)'
        begin += Math.ceil(basic + angle - begin) * 0.1
      }, 70)
    },
    locationPan() {
      if (this.baseInfo && this.baseInfo.hasDrawn && this.baseInfo.lastDrawId) {
        // 转盘定位到上次选中
        const tempArr = this.panData || []
        const originIndex = tempArr.findIndex((item) => item.id === this.baseInfo.lastDrawId)
        if (originIndex > -1) {
          let angle = 0
          switch (originIndex) {
            case 0:
              angle = -30
              break
            case 1:
              angle = 270
              break
            case 2:
              angle = 210
              break
            case 3:
              angle = 150
              break
            case 4:
              angle = 90
              break
            case 5:
              angle = 30
              break
          }
          this.$refs.wapper.style.transform = 'rotate(' + angle + 'deg)'
        }

        // 滚动条定位到底部
        try {
          if (document.body) {
            let top = 5000
            if (document.body.scrollHeight) {
              top = document.body.scrollHeight
            }
            document.body.scrollTo({ top: top, behavior: 'smooth' })
          }
        } catch (err) {
          console.log('try catch err:', err)
        }
      }
    },
    // 倒计时相关
    startCountdown() {
      const countdownFn = (currentTime) => {
        // 避免过于频繁的更新
        if (currentTime - this.lastTime >= 1000) {
          const remainingTime = this.endTime - Date.now()

          if (remainingTime <= 0) {
            this.showTime = '00:00:00'
            this.stopAct()
            return
          }

          this.showTime = `${this.formatTime(remainingTime)}`
          this.lastTime = currentTime
        }

        // 继续下一帧
        this.animationFrameId = requestAnimationFrame(countdownFn)
      }

      this.animationFrameId = requestAnimationFrame(countdownFn)
    },
    // 格式化时间显示
    formatTime(ms) {
      if (ms <= 0) return '00:00:00'

      const totalSeconds = Math.floor(ms / 1000)
      const hours = Math.floor(totalSeconds / 3600)
      const minutes = Math.floor((totalSeconds % 3600) / 60)
      const seconds = totalSeconds % 60

      return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
    },
    // 数据相关
    stopAct() {
      if (this.baseInfo) {
        this.baseInfo.ifValid = false
        this.baseInfo.hasDrawn = false
      }
      //
      else {
        this.initData()
      }
    },
    // 业务方法
    async handleClaim() {
      // 调用接口校验当前状态
      const nowState = await apiNineDotNinetyNineAct()
      if (!nowState || (nowState && !nowState.hasDrawn)) {
        this.initData()
        return
      }
      // 初始数据校验当前状态
      if (!this.baseInfo) {
        return
      }

      // 支付基础参数
      const payQuery = {
        scene: 'activity',
        activityType: this.baseInfo.activityType,
        gid: this.baseInfo.gid,
        productId: this.baseInfo.productId,
        amount: this.baseInfo.amount,
        backType: 'previous',
      }

      // price currency参数控制 原生支付的显示
      // 下面这些版本之后，payGoogleFromWeb 才支持服务端需要回传的avtivityType
      // vava
      let appChannel = ''
      try {
        appChannel = this.getChannel()
        if (appChannel === 'vvg') {
          const appVerionsLimit = compareVersion(this.appInfo.version, '4.2.1')
          if (appVerionsLimit > 0) {
            payQuery.useWebPay = '1'
            payQuery.price = this.handleDiv100(this.baseInfo.price)
            payQuery.currency = this.baseInfo.currency
          }
        }
        // joychat
        if (appChannel === 'jcg') {
          const appVerionsLimit = compareVersion(this.appInfo.version, '2.3.0')
          if (appVerionsLimit > 0) {
            payQuery.useWebPay = '1'
            payQuery.price = this.handleDiv100(this.baseInfo.price)
            payQuery.currency = this.baseInfo.currency
          }
        }
        // echo
        if (appChannel === 'eca') {
          const appVerionsLimit = compareVersion(this.appInfo.version, '1.2.1')
          if (appVerionsLimit > 0) {
            payQuery.useWebPay = '1'
            payQuery.price = this.handleDiv100(this.baseInfo.price)
            payQuery.currency = this.baseInfo.currency
          }
        }
        if (appChannel === 'ecg') {
          const appVerionsLimit = compareVersion(this.appInfo.version, '1.3.0')
          if (appVerionsLimit > 0) {
            payQuery.useWebPay = '1'
            payQuery.price = this.handleDiv100(this.baseInfo.price)
            payQuery.currency = this.baseInfo.currency
          }
        }
        // kiko
        if (appChannel === 'kkg') {
          payQuery.useWebPay = '1'
          payQuery.price = this.handleDiv100(this.baseInfo.price)
          payQuery.currency = this.baseInfo.currency
        }
      } catch (err) {
        console.error(err)
      }

      this.traceAction({ Action: 'Click', APosition: 'button', AValue: 'repurchase-9.99-click-topay' })

      // echo 支付页面
      if (appChannel === 'eca' || appChannel === 'ecg') {
        this.$router.push({
          path: '/echo-pay',
          query: payQuery,
        })
        return
      }

      // 其他 支付页面
      this.$router.push({
        path: '/pay',
        query: payQuery,
      })
    },
    // 获得页面数据
    initData() {
      apiNineDotNinetyNineAct().then((resData) => {
        if (resData && !resData.error) {
          this.baseInfo = resData

          // 初始化 转盘数据
          if (resData.wheelConfig && resData.wheelConfig && resData.wheelConfig.length) {
            this.panData = resData.wheelConfig.map((item) => {
              return {
                id: item.id,
                discount: item.desc.replace('%', ''),
                ratio: null,
              }
            })
          }

          this.$nextTick(() => {
            this.locationPan()
          })

          // 初始化倒计时
          try {
            const now = Date.now()
            this.endTime = resData.expireTimeMills
            this.startCountdown(now)
          } catch (err) {
            this.showTime = ''
          }
        }
      })
    },
  },
  created() {
    this.appInfo = this.$client.getAppInfo() || { version: '' }
    this.initData()

    this.traceAction({ Action: 'Click', APosition: 'entrance', AValue: 'repurchase-9.99' })
  },
}
</script>

<style lang="less" scoped>
.recharge-root {
  width: 375px;
  margin: auto;
  min-height: 100vh;
  padding-bottom: 90px;
  background-color: #ffdc6a;

  .custom-nav-block {
    background-color: #ff9f4c;
  }

  .recharge-top {
    position: relative;
    background-color: #ff9f4c;
    .recharge-tit {
      display: block;
      width: 375px;
      margin: auto;
    }

    .rec-date-block {
      position: relative;
      width: 100%;
      margin-top: -22px;
      font-size: 0;
      > img {
        width: 100%;
      }

      .recharge-date-block {
        position: absolute;
        top: 32px;
        left: 50%;
        transform: translateX(-50%);

        border-radius: 100px;
        background: #321904;
        border: 4px solid #321904;

        .recharge-date {
          min-width: 194px;
          padding: 2px 16px;
          border-radius: 100px;
          border: 1px solid rgba(255, 248, 248, 0.8);
          background: #321904;

          span {
            color: #ffffff;
            font-family: 'TikTokSans-Regular';
            font-size: 20px;
            line-height: 26px;
            margin: 0 2px;
            white-space: nowrap;

            &:nth-child(2) {
              color: #93ea07;
            }
          }
        }
      }
    }
  }

  .recharge-con {
    position: relative;
    width: 343px;
    margin: 10px auto 0;
    padding: 10px 6px 6px 6px;
    border-radius: 30px;
    background: #ff9424;

    .recharge-tit {
      display: flex;
      align-items: center;
      justify-content: center;

      -webkit-text-stroke-width: 1px;
      -webkit-text-stroke-color: #321904;
      font-family: 'TikTokSans-Regular';
      font-size: 20px;
      font-style: normal;
      font-weight: 600;
      background: linear-gradient(180deg, #fff967 22.58%, #fffffe 77.42%);
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;

      img {
        width: 17px;
        height: 17px;
        margin: 0 4px;
      }
    }

    .wheel-pan {
      width: 291px;
      height: 291px;
      margin: 24px auto;
      display: flex;
      align-items: center;
      justify-content: center;
      background: url(./images/wheel-pan.webp) top left / 100% auto no-repeat;
      position: relative;

      .wheel-pointer {
        position: absolute;
        top: 50%;
        left: 50%;
        z-index: 99;
        margin-top: -30px;
        margin-left: -20px;
        width: 40px;
        height: 52px;
        background: url(./images/wheel-pointer.webp) top left / 100% auto no-repeat;
      }
    }

    .recharge-con-block {
      width: 295px;
      margin: 10px auto;
      padding: 24px 16px 0;
      border-radius: 24px;
      background: #fff6da;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      .con-block-btn {
        min-width: 243px;
        min-height: 64px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 16px;
        border: 4px solid #fdecd5;
        background: linear-gradient(180deg, #fe3740 0%, #fb7c2e 100%);
        box-shadow: 0 2px 4px 0 rgba(191, 88, 23, 0.2), 0 2px 1px 2px rgba(255, 255, 255, 0.8) inset;

        color: #fffcff;
        text-align: center;
        font-family: 'TikTokSans-Regular';
        font-size: 24px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;

        position: relative;

        .btn-tips-root {
          position: absolute;
          top: -23px;
          right: -12px;
          min-width: 72px;
          min-height: 32px;

          .btn-tips-con {
            min-width: 72px;
            height: 24px;
            padding: 0 12px;
            border-radius: 8px;
            background: linear-gradient(180deg, #e0ff1a 0%, #93ea07 100%);

            color: #3e5600;
            text-align: center;
            font-family: 'TikTokSans-Regular';
            font-size: 15px;
            font-weight: 500;

            position: relative;
            img {
              width: 14px;
              height: 8px;
              position: absolute;
              bottom: -8px;
              right: 20px;
            }
          }
        }
      }

      .con-block-btn.disable {
        border-radius: 16px;
        border: 4px solid #f1f1f1;
        background: linear-gradient(180deg, #c1c1c1 0%, #e4e4e4 100%);
        box-shadow: 0 2px 4px 0 rgba(136, 136, 136, 0.2), 0 2px 1px 2px rgba(255, 255, 255, 0.8) inset;
      }

      .recharge-tips {
        margin: 8px 0;
        color: #321904;
        text-align: center;
        font-family: 'TikTokSans-Regular';
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
      }

      .recharge-coins {
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: 40px;
          height: 40px;
          margin: 0 8px;
        }
        i {
          color: #321904;
          font-family: 'Inter-Tight';
          font-size: 30px;
          font-style: italic;
          font-weight: 600;
        }
      }

      .rec-fir-deliver {
        width: 100%;
        margin-top: 24px;
        font-family: 'TikTokSans-Regular';
        font-size: 17px;
        color: #333333;
        height: 20px;
        line-height: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        .deliver-l,
        .deliver-r {
          flex: 1;
          position: relative;
          opacity: 0.5;
        }
        .deliver-l {
          div {
            width: 100%;
            height: 1px;
            background: linear-gradient(270deg, #333333 0%, rgba(255, 255, 255, 0) 100%);
          }
        }
        .deliver-r {
          div {
            width: 100%;
            height: 1px;
            background: linear-gradient(270deg, rgba(255, 255, 255, 0) 0%, #333333 100%);
          }
        }
        .rec-fir-deliver-text {
          margin: 0 3px;
        }
      }

      .rec-gifts {
        width: 100%;
        margin-top: 16px;
        display: flex;
        align-items: center;
        .gift-item {
          width: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          img {
            width: 30px;
            margin: 0 5px;
          }
          color: #321904;
          font-family: 'Inter-Tight';
          font-size: 20px;
          font-style: italic;
          font-weight: bold;
          line-height: normal;
        }
      }
    }

    .pd-24 {
      padding-bottom: 24px;
    }
  }

  .top-mg25 {
    margin-top: -25px;
  }

  .recharge-con-tips {
    margin-top: 26px;
    color: #321904;
    text-align: center;
    font-family: 'TikTokSans-Regular';
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }

  .recharge-btn {
    width: 262px;
    min-height: 52px;
    margin: 12px auto 0;
    background: #ff9424;
    border-radius: 30px;

    display: flex;
    align-items: center;
    justify-content: center;

    position: relative;

    img {
      width: 24px;
      margin: 0 3px;
    }

    i {
      color: #321904;
      text-align: center;
      font-family: 'TikTokSans-Regular';
      font-size: 20px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
    }
    span {
      margin: 0 3px;
      color: rgba(50, 25, 4, 0.5);
      text-align: center;
      font-family: 'TikTokSans-Regular';
      font-size: 15px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      text-decoration-line: line-through;
    }

    .discount {
      position: absolute;
      right: 0;
      top: -12px;
      display: inline-flex;
      height: 24px;
      padding: 0 12px;
      justify-content: center;
      align-items: center;
      flex-shrink: 0;

      color: #fff;
      text-align: center;
      font-family: 'TikTokSans-Regular';
      font-size: 15px;
      font-weight: bold;
      border-radius: 100px;
      background: #ff5a4a;
    }
  }

  .mt-60 {
    margin-top: 60px;
  }

  .cannot-claim {
    pointer-events: none;
    background: #cccccc;

    i,
    span {
      color: rgba(255, 255, 255, 0.5);
    }
  }

  .mask {
    width: 100%;
    height: 100%;
    background: var(--mask-black-75, rgba(0, 0, 0, 0.75));

    position: fixed;
    left: 0;
    top: 0;
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
    .dialog {
      min-width: 245px;
      min-height: 273px;
      display: flex;
      flex-direction: column;
      align-items: center;
      background: url(./images/dialog-bg.webp) top left / 100% 100% no-repeat;
      position: relative;

      div {
        &:nth-child(1) {
          padding: 0 45px;
          margin-top: 10px;
          color: #321904;
          text-align: center;
          font-family: 'TikTokSans-Regular';
          font-size: 20px;
          font-weight: 500;
          line-height: 26px;
        }

        &:nth-child(2) {
          margin-top: 10px;
          color: #321904;
          text-align: center;
          font-family: 'TikTokSans-Regular';
          font-size: 60px;
          font-style: normal;
          font-weight: 900;
          line-height: 72px;
        }

        &:nth-child(3) {
          color: #321904;
          font-family: 'TikTokSans-Regular';
          font-size: 36px;
          font-style: normal;
          font-weight: 900;
          line-height: 43px;
        }

        &:nth-child(4) {
          position: absolute;
          left: 50%;
          bottom: 26px;
          transform: translateX(-50%);
          min-width: 122px;
          height: 32px;
          padding: 0 10px;
          display: flex;
          justify-content: center;
          align-items: center;

          border-radius: 30px;
          background: #ff6917;

          color: #fff;
          font-family: 'TikTokSans-Regular';
          font-size: 15px;
          font-weight: bold;
        }
      }
    }
  }
}

.outher {
  width: 245px;
  height: 245px;
  position: relative;
  border-radius: 50%;
  overflow: hidden;

  .wapper {
    width: 246px;
    height: 246px;
    border-radius: 50%;
    .part1 {
      position: absolute;
      width: 123px;
      height: 246px;
      right: 0;
      overflow: hidden;
      text-align: center;

      .text {
        position: absolute;
        top: 23px;
        left: 23%;
        transform: rotate(30deg);
        text-align: center;
      }

      .item {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        transform-origin: left center;
      }

      .item.one {
        background-color: #fefaf3;
        z-index: 1;
      }

      .item.two {
        background-color: #fcefa2;
        transform: rotate(60deg);
        z-index: 2;
      }

      .item.three {
        background-color: #fefaf3;
        transform: rotate(120deg);
        z-index: 3;
      }
    }

    .part2 {
      position: absolute;
      width: 123px;
      height: 246px;
      left: 0;
      overflow: hidden;

      .text {
        position: absolute;
        top: 23px;
        left: 47%;
        transform: rotate(-30deg);
        text-align: center;
      }

      .item {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        transform-origin: right center;
      }

      .item.four {
        background-color: #fcefa2;
        transform: rotate(-120deg);
        z-index: 3;
      }

      .item.five {
        background-color: #fefaf3;
        transform: rotate(-60deg);
        z-index: 2;
      }

      .item.six {
        background-color: #fcefa2;
        z-index: 1;
      }
    }

    .part1,
    .part2 {
      .gotted {
        background-color: #ff5a4a !important;
        .text {
          .discount,
          .union {
            color: #fcefa2 !important;
          }
        }
        .txt {
          color: #fcefa2 !important;
        }
      }
    }
  }

  .text {
    font-size: 0;
    .discount {
      color: #f74100;
      text-align: center;
      font-family: 'Inter-Tight';
      font-size: 24px;
      font-weight: 700;
      line-height: 26px;
    }

    .union {
      color: #f74100;
      font-family: 'Inter-Tight';
      font-size: 15px;
      font-style: normal;
      font-weight: 600;
      line-height: 17px;
    }

    .txt {
      color: #f74100;
      font-family: 'Inter-Tight';
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }
  }
}
</style>
